module.exports = __webpack_public_path__ + "static/media/landingCollaborator1.1a8f4fe7.jpg";